/**
 * Data layer template.
 * @param {string} label of data layer.
 * @param {object} vars of data what need to push.
 * @param {string} eventName.
 * @param {string} eventAction.
 * @param {string} eventCategory.
 */
export default function dataLayerPush(
  label,
  vars,
  eventName,
  eventAction,
  eventCategory = "Content Interactions"
) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    eventCategory,
    eventAction,
    eventLabel: label,
    eventValue: undefined,
    eventOrigin: "front-end",
    eventVars: vars,
  });
}
